import React from "react";
import MaskedInput from "react-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";

const numberMask = createNumberMask({
  prefix: "",
  suffix: "",
  integerLimit: 18,
});

export default function priceMask(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={numberMask}
      keepCharPositions={false}
    />
  );
}
